import Constatnt, { InputRegex, InputTypesEnum } from "./constant";
import CryptoJS from 'crypto-js';
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import React, { useEffect, useMemo } from "react";
// import { useDispatch, useSelector } from "react-redux";
import { useSelector } from "react-redux";

import dayjs from "dayjs";
import ExcelJS from 'exceljs';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
// import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";


import AWS from 'aws-sdk'
import Globals from './constant'

const uploadToS3 = (file, folderName, acl = 'public-read') => {
  return new Promise((resolve, reject) => {
    reject('No data found')
    // AWS.config.update({
    //   accessKeyId: Globals.S3_ACCESS_KEY,
    //   secretAccessKey: Globals.S3_SECRET_ACCESS_KEY,
    //   region: Globals.S3_REGION,
    // })

    // const s3 = new AWS.S3()

    // const params = {
    //     Bucket: Globals.S3_BUCKET_NAME,
    //     Key: `${folderName}/${file.name}`,
    //     Body: file,
    //     ContentType: file.type,
    //     ACL: acl
    // }
    

    // s3.upload(params, (err, data) => {
  
    //   if (err) {
    //     reject(err)
    //   } else {

    //     resolve(data) 
    //   }
    // })
  })
};






//  --- aws  ----------------------
export default function COUNTRY_LIST_OPTION(setValue, fieldName, userData) {
    // const dispatch = useDispatch();
    const { countryList: { data: countryList }, } = useSelector((state) => state.masterslice);

    useEffect(() => {
    
    }, []);

    let countryData = useMemo(() => {
        return countryList?.map((country) => {
            let dd = '+' + country?.phonecode?.replace('+', '')
            if ((dd === '+966' && !userData) || dd === userData?.[fieldName]) {
                setValue(fieldName, dd);
                return (
                    <option key={country?.id} value={dd} selected>{dd}</option>
                );
            } else {
                return (
                    <option key={country?.id} value={dd}>{dd}</option>
                );
            }
        });
    }, [countryList]);

    return countryData
}

const KEY = CryptoJS.enc.Utf8.parse(Constatnt.KEY);
const IV = CryptoJS.enc.Utf8.parse(Constatnt.IV);

export const Encryption = (request = {}, isStringify) => {
    const requestData = isStringify ? JSON.stringify(request) : request;
    let encrypted = CryptoJS.AES.encrypt(requestData, KEY, { iv: IV }).toString();
  
    return encrypted
}

export const Decryption = async (response) => {
    let decrypted = await CryptoJS.AES.decrypt(response.toString(), KEY, { iv: IV });
    let decryptedData = await JSON.parse(decrypted.toString(CryptoJS.enc.Utf8))
    if (decryptedData?.code === '0') {
        TOAST_ERROR(decryptedData?.message);
    }
    return decryptedData;
}

// export function LoginRedirection(response) {
//     const navigate = useNavigate();
//     localStorage.setItem('auth', JSON.stringify(response.data));
//     localStorage.setItem('token', response.data.token);
//     navigate('/home');
// }

export const loginRedirection = (data) => {
    // const navigate = useNavigate();
    localStorage.setItem("PisLogin", true);
    localStorage.setItem("Drole", data?.user_type);
    localStorage.setItem('Ptoken', data?.token);
    localStorage.setItem("DadminData", JSON.stringify(data));
}

export const logoutRedirection = () => {
    localStorage.removeItem('PisLogin');
    localStorage.removeItem('Drole');
    localStorage.removeItem('Ptoken');
    localStorage.removeItem('DadminData');
    // navigate('/login');

}

const capitalizeWords = (str) => {
    const hyphenIndex = str.indexOf("-");
    if (hyphenIndex !== -1) {
        const words = str.split("-");
        const capitalizedWords = words.map((word) => word.charAt(0).toUpperCase() + word.slice(1));
        return capitalizedWords.join(" ");
    } else {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
};

const formatDate = (date, format) => {
    return dayjs(date).format(format);
};

const SWIT_SUCCESS = (message) => {
    return Swal.fire({
        position: 'top-center',
        icon: 'success',
        title: message,
        showConfirmButton: false,
        timer: 1800
    })
};

const SWIT_DELETE = (message) => {
    return Swal.fire({
        title: 'Are you sure?',
        text: message ? message : "",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
    })
};



const SWIT_CHANGE_PASSWORD = (message) => {
    return Swal.fire({
        title: 'Are you sure?',
        text: 'Do u want to reset password',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Change it!'
    })
};



//SWIT_CLEAR_NOTIFICATION

const SWIT_CLEAR_NOTIFICATION = (message) => {
    return Swal.fire({
        title: 'Are you sure?',
        text: message ? message : "Do u want to clear notification",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, clear it!'
    })
};



const SWIT_STATUS_CHANGE = (message) => {
    return Swal.fire({
        title: 'Are you sure?',
        text: 'You want to change status',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Change it!'
    })
};


const SWIT_SUBSCRIPTION_PURCHASE = (message) => {
    return Swal.fire({
        title: 'Are you sure?',
        text: 'You want to purchase subscription plan.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, I want to purchase.!'
    })
};
// const SWIT_SUBSCRIPTION_CANCEL_SUCCESS = (message) => {
//     return Swal.fire({
//         position: 'top-center',
//         icon: 'success',
//         title: message ? message : 'Your subscription plan  has been canceled.',
//         showConfirmButton: false,
//         timer: 1500
//     })
// };


const SWIT_SUBSCRIPTION_CANCEL_SUCCESS = (message) => {
    return Swal.fire({
        title: 'Are you sure?',
        text: 'You want to cancel subscription plan',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, I want to cancel it!'
    })
};


const SWIT_DELETE_SUCCESS = (message) => {
    return Swal.fire({
        position: 'top-center',
        icon: 'success',
        title: message ? message : 'Your data has been deleted.',
        showConfirmButton: false,
        timer: 1500
    })
};

const TOAST_SUCCESS = (message) => {
    return toast.success(message);
};

const TOAST_INFO = (message) => {
    return toast.info(message);
};

const TOAST_ERROR = (message) => {
    return toast.error(message);
};

const TOAST_WARNING = (message) => {
    return toast.warning(message);
};

const SWIT_LOGOUT = (message) => {
    return Swal.fire({
        title: 'Are you sure logout?',
        text: message ? message : "",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, logout it!'
    })
};

export const convertToBase64 = async (file) => {
    if (file.type.includes("video")) return URL.createObjectURL(file);
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.onload = () => {
            resolve(fileReader.result);
        };
        fileReader.onerror = reject;
        file && fileReader.readAsDataURL(file);
    });
};

export const Language = (keyword) => {
    // const { t, i18n } = useTranslation();
    const { t } = useTranslation();
    return t(keyword)
}

const MOBILE_VALIDATION = () => {
    return ({ required: "Please enter mobile number", pattern: { value: /^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/i, message: "Please enter valid mobile number", }, maxLength: { value: 10, message: "Mobile number should not exceed 10 characters" }, minLength: { value: 8, message: "Please enter atleast 8 digits for mobile number" } })
};

const EMAIL_VALIDATION = () => {
    return ({ required: "Please enter email address", pattern: { value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, message: "Please enter valid email address", }, })
};

const   PASSWORD_VALIDATION = () => {
    return ({ required: "Please enter password", pattern: { value: /^.*(?=.{8,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/, message: "Password must contain at least 8 characters, one uppercase, one number and one special case character", }, })
};

// const CONFIRM_PASSWORD_VALIDATION = (value) => {
//     return ({ required: "Please enter confirm password", pattern: { value: /^.*(?=.{8,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/, message: "Confirm password must contain at least 8 characters, one uppercase, one number and one special case character", }, validate: (v) => v === value || "Password do not match" })
// };

const FIRST_NAME_VALIDATION = () => {
    return ({
        required: "Please enter first name",
        minLength: {
            value: 2,
            message: "Invalid first name."
        },
        pattern: {
            value: /^[A-Za-z]+$/,
            message: "First name should only contain letters"
        }
    })
};

const TEXT_VALIDATION = (fieldName) => {
    return ({
        required: "Please enter " + fieldName,
        minLength: {
            value: 2,
            message: `Invalid ${fieldName}.`
        },
        pattern: {
            value: /^[A-Za-z]+$/,
            message: `${fieldName} should only contain letters`
        }
    })
};

const NUMBER_VALIDATION = (fieldName, minLength = false, maxLength = false) => {
    return ({
        required: "Please enter " + fieldName,
        ...(minLength && {
            minLength: {
                value: minLength,
                message: `Invalid ${fieldName}.`
            },
        }),
        ...(maxLength && {
            maxLength: {
                value: maxLength,
                message: `${fieldName} should not exceed ${maxLength} numbers`
            },
        }),
        pattern: {
            value: /^[0-9]+$/,
            message: `${fieldName} should only contain numbers`
        }
    })
};

const LAST_NAME_VALIDATION = () => {
    return ({
        required: "Please enter last name",
        minLength: {
            value: 2,
            message: "Invalid last name."
        },
        pattern: {
            value: /^[A-Za-z]+$/,
            message: "Last name should only contain letters"
        }
    })
};

const ExportToCSV = (data, fileName) => {
    try {
        let csvContent = '';
        if (Array.isArray(data) && data.length > 0) {
            if (Array.isArray(data[0])) {
                csvContent = data.map(row => row.join(",")).join("\n");
            } else if (typeof data[0] === 'object') {
                const headers = Object.keys(data[0]);
                csvContent += headers.join(",") + "\n";
                csvContent += data.map(row =>
                    headers.map(header => row[header]).join(",")
                ).join("\n");
            }
        }
        const blob = new Blob([csvContent], { type: 'text/csv' });

        if (window.navigator.msSaveBlob) {
            window.navigator.msSaveBlob(blob, `${fileName}.csv`);
        } else {
            const link = document.createElement("a");
            if (link.download !== undefined) {
                const url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", `${fileName}.csv`);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            } else {
                TOAST_ERROR('Your browser does not support downloading files');
            }
        }
    } catch (error) {
        TOAST_ERROR(error);
    }
};

const ExportToExcel = (data, fileName) => {
    try {
        const columns = Object.keys(data[0])?.map(item => item?.replace('_', ' ')?.toUpperCase());
        const columns1 = Object.keys(data[0]);

        const wb = new ExcelJS.Workbook();
        const ws = wb.addWorksheet('Sheet 1');

        ws.addRow(columns);

        data.forEach(item => {
            const row = [];
            columns1.forEach(column => {
                row.push(item[column]);
            });
            ws.addRow(row);
        });

        wb.xlsx.writeBuffer().then(buffer => {
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.setAttribute('download', `${fileName}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    } catch (error) {
        TOAST_ERROR(error);
    }
};

const ExportToPdf = (data, fileName, header) => {
    try {
        const doc = new jsPDF();
        doc.setFontSize(18);
        doc.text(header, 14, 10);
        doc.setLineWidth(0.5);
        doc.line(14, 12, 196, 12);
        doc.setFontSize(18);

        const columns = Object.keys(data[0])?.map(item => item?.replace('_', ' ')?.toUpperCase());
        const tableData = data.map(item => Object.values(item));
        doc.autoTable(columns, tableData);
        doc.save(`${fileName}.pdf`);
    } catch (error) {
        TOAST_ERROR(error);
    }
};



const allowLettersAndSpaces = (event) => {
    const input = String.fromCharCode(event.which);
    if (!/^[A-Za-z]*$/.test(input) && input !== ' ') { // Adding check for space character
        event.preventDefault();
    }
};


export const handleFullscreenClick = () => {
    if (document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement) {
        // If already in fullscreen, exit fullscreen
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        }
    } else {
        // If not in fullscreen, request fullscreen
        if (document.documentElement.requestFullscreen) {
            document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
            document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
            document.documentElement.webkitRequestFullscreen();
        } else if (document.documentElement.msRequestFullscreen) {
            document.documentElement.msRequestFullscreen();
        }
    }





};

export const allowNumber = (event) => {
    const input = String.fromCharCode(event.which);
    if (!InputRegex.NUMBER_REGEX.test(input) && input !== ' ') { // Adding check for space character
        event.preventDefault();
    }
}

export const handelInputText = (event) => {
    // const { value, name } = event.target;
    const { name } = event.target;
    
    const input = String.fromCharCode(event.which);
    isValidInput(name, input, event)
}

export const isValidInput = (inputType, text, event) => {

    


    var pattern = /^[A-Za-z0-9, ]+$/;

    if (inputType === InputTypesEnum.FIRSTNAME || inputType === InputTypesEnum.LASTNAME || InputTypesEnum.USERNAME) {

        pattern = InputRegex.FIRSTNAME_REGEX;
    } else if (inputType === InputTypesEnum.EMAIL) {

        pattern = InputRegex.EMAIL_REGEX;
    } else if (inputType === InputTypesEnum.ONCHANGEEMAIL) {

        pattern = InputRegex.ONCHANGEEMAIL_REGEX;

    } else if (inputType === InputTypesEnum.MOBILE) {

        pattern = InputRegex.MOBILE_REGEX;

    } else if (inputType === InputTypesEnum.PASSWORD || InputTypesEnum.OLDPASSWORD || InputTypesEnum.NEWPASSWORD) {

        pattern = InputRegex.PASSWORD_REGEX;

    } else if (inputType === InputTypesEnum.ONCHANGEPASSWORD) {

        pattern = /^[A-Za-z0-9!@#$%&*]+$/;

    } else if (inputType === InputTypesEnum.ADDRESS) {

        pattern = InputRegex.ADDRESS_REGEX;

    } else if (inputType === InputTypesEnum.CITY || inputType === InputTypesEnum.COUNTRY || inputType === InputTypesEnum.NAME) {

        pattern = InputRegex.CHAR_REGEX;

    } else if (inputType === InputTypesEnum?.ZIPCODE) {

        
        pattern = InputRegex.NUMBER_REGEX;
    }

    if (pattern.test(text) && text !== ' ') {
        return pattern.test(text);
    } else {
        event.preventDefault();
    }
};

export const textValidation = (inputType, value) => {

    

    if (inputType === InputTypesEnum.FIRSTNAME) {
        return ({
            required: "Enter first name",
            minLength: {
                value: 2,
                message: "Invalid first name."
            },
            pattern: {
                value: InputRegex.FIRSTNAME_REGEX,
                message: "First name should only contain letters"
            }
        })
    }

    if (inputType === InputTypesEnum.LASTNAME) {
        return ({
            required: "Enter last name",
            minLength: {
                value: 2,
                message: "Invalid last name."
            },
            pattern: {
                value: InputRegex.FIRSTNAME_REGEX,
                message: "Last name should only contain letters"
            }
        })
    }

    if (inputType === InputTypesEnum.EMAIL) {

        return ({ required: "Enter your email address", pattern: { value: InputRegex.EMAIL_REGEX, message: "Please enter valid email address", }, })
    }

    if (inputType === InputTypesEnum.PASSWORD) {
        return ({
            required: "Please enter password",
            pattern: {
                value: InputRegex.PASSWORD_REGEX,
                message: "Password must contain at least 8 characters, one uppercase, one number and one special case character",
            },
        })
    }

    if (inputType === InputTypesEnum.OLDPASSWORD) {
        return ({
            required: "Enter old password",
            pattern: {
                value: InputRegex.PASSWORD_REGEX,
                message: "Password must contain at least 8 characters, one uppercase, one number and one special case character",
            },
        })
    }

    if (inputType === InputTypesEnum.NEWPASSWORD) {
        return ({
            required: "Enter new password",
            pattern: {
                value: InputRegex.PASSWORD_REGEX,
                message: "Password must contain at least 8 characters, one uppercase, one number and one special case character",
            },
        })
    }

    if (inputType === InputTypesEnum.CONFIRM_PASSWORD) {
        return ({
            required: "Enter confirm password",
            pattern: {
                value: InputRegex.PASSWORD_REGEX,
                message: "Confirm password must contain at least 8 characters, one uppercase, one number and one special case character",
            },
            validate: (v) => v === value || "Password do not match"
        })
    }

}





    
    

    
    

export { uploadToS3,capitalizeWords, allowLettersAndSpaces, PASSWORD_VALIDATION, formatDate,SWIT_STATUS_CHANGE, SWIT_SUCCESS,SWIT_CHANGE_PASSWORD, SWIT_DELETE, SWIT_DELETE_SUCCESS,SWIT_SUBSCRIPTION_CANCEL_SUCCESS,SWIT_SUBSCRIPTION_PURCHASE, TOAST_SUCCESS, TOAST_INFO, TOAST_ERROR, TOAST_WARNING, SWIT_LOGOUT, FIRST_NAME_VALIDATION, TEXT_VALIDATION, NUMBER_VALIDATION, LAST_NAME_VALIDATION, EMAIL_VALIDATION, MOBILE_VALIDATION,SWIT_CLEAR_NOTIFICATION, ExportToCSV, ExportToExcel, ExportToPdf };